import { AxiosResponse } from 'axios';
import $api from '@/http/index';
import { ISupplyScheduleTable } from '@models/supplySchedule/ISupplyScheduleTable';

export class SupplyScheduleService {
    static async fetchTableData(docId: string, tableKey: string): Promise<AxiosResponse<ISupplyScheduleTable>> {
        return $api.get<ISupplyScheduleTable>(`/SupplySchedule/${docId}/${tableKey}`);
    }
}
